import gsap from 'gsap';
import {displayPublicationListingFn} from './publications_display';

//Initiating an array with every checked or changed input of the current view.
const checkedArray = [];
window.addEventListener('DOMContentLoaded', () => {
  Object.values(document.querySelectorAll('input:checked, input.changed')).map(item => {
    checkedArray.push(item.id);
  });
  resetFilter();
});

/****
 *    Function : filterHandle and detectChanges
 *    Usage : this functions aims to handle the filters of the publication archive page
 ****/
const filterHandle = () => {
  const form = document.querySelector('#filterForm');
  const keyword = document.querySelector('#filterKeyword');

  if (form) {
    if (checkedArray.length > 0) {
      document.getElementById('resetFilter').removeAttribute('style');
    }

    const checkboxes = form.querySelectorAll('input[type=checkbox]');
    const keywordInput = keyword.querySelector('input');

    //We store the initial value of the keyword input
    const keywordInputValue = keywordInput.value;

    //First we track the changes changes occurring in the checkboxes of the form.
    Object.values(checkboxes).map(input => {
      //For each checkbox category, we have a hidden text input to store the data
      const inputHidden = input.closest('fieldset').querySelector('input[hidden]');

      input.addEventListener('change', () => {
        //We get the datas of the hidden input and store them in an array to be able to easily add/remove a checked/unchecked item.
        const valuesArray = inputHidden.value.split(',');
        //The changed checkbox value :
        const value = input.id.split('-')[1];

        //If the status of the input changes to "checked"
        if (input.checked) {
          if (!valuesArray.find(item => item === value)) {
            //We store the value of the current checkbox in the array created above
            valuesArray.push(value);
          }
        }
        else { //If the status of the input changes to "unchecked" we remove the value from the same array
          valuesArray.splice(valuesArray.findIndex(item => item === value), 1);
        }

        //We finally update the hidden input value with the array of values
        inputHidden.value = valuesArray.join(',');
        detectChanges();
      });
    });

    //Detecting changes in the Keyword input search
    keywordInput.addEventListener('keyup', () => {
      const inputHidden = form.querySelector('input[name=keywordInput][hidden]');

      //changing the hidden input value with the keyword input value.
      inputHidden.value = keywordInput.value;

      //We add/remove a class "changed" if the value is different of the initial input value
      if (keywordInput.value !== keywordInputValue) {
        keywordInput.classList.add('changed');
      }
      else {
        keywordInput.classList.remove('changed');
      }

      detectChanges();
    });

    //Parent/Children input handle
    const parentInputs = form.querySelectorAll('.filter--input > .checkbox--wrapper input[type=checkbox]');
    const childrenInputs = form.querySelectorAll('.filter--input > .filter--children .checkbox--wrapper input[type=checkbox]');

    //Switch off/on checked input
    Object.values(childrenInputs).map(input => {
      input.addEventListener('change', () => {
        const inputSiblingsChecked = input.closest('.filter--input').querySelectorAll('.filter--children input[type=checkbox]:checked');
        const inputSiblings = input.closest('.filter--input').querySelectorAll('.filter--children input[type=checkbox]');
        const parentInput = input.closest('.filter--input').querySelector('.checkbox--wrapper input[type=checkbox]');

        console.log('siblings checked', inputSiblingsChecked.length);
        console.log('siblings', inputSiblings.length);

        if (inputSiblingsChecked.length === inputSiblings.length) {
          parentInput.checked = true;
          parentInput.classList.remove('pre-check');
        } else if (inputSiblingsChecked.length > 0) {
          parentInput.checked = false;
          parentInput.classList.add('pre-check');
        } else {
          parentInput.checked = false;
          parentInput.classList.remove('pre-check');
        }
      });
    });

    //Switch off/on checked input
    Object.values(parentInputs).map(input => {
      input.addEventListener('change', () => {
        const inputChildren = input.closest('.filter--input').querySelectorAll('.filter--children input[type=checkbox]');

        if (!input.checked) {
          Object.values(inputChildren).map(children => {
            children.checked = false;
            input.classList.remove('pre-check');
          });
        }
        else {
          Object.values(inputChildren).map(children => {
            children.checked = true;
          });
        }
      });
    });
  }

  //When submit the keyword input search form
  keyword?.addEventListener('submit', e => {
    //We do nothing but trigger the filter Form submit event.
    e.preventDefault();
    e.stopPropagation();

    const input = keyword.querySelector('input');

    if (input.value !== '') {
      form.submit();
    }
  });
};

const detectChanges = () => {

  setTimeout(async () => {
    const wrapper = document.querySelector('.publications--wrapper');
    const listing = document.querySelector('.publications--listing');

    wrapper.classList.remove('loaded');

    const resets = document.querySelectorAll('.button--reset');
    const checked = document.querySelectorAll('input:not(.pre-check):checked, input.changed');
    const query = {};
    const newCheckedArray = [];

    [...checked].map(item => {
      const slug = item.id.split('-')[0];
      const key = slug + (!['keywordInput', 'from_year', 'to_year'].includes(slug) ? '_terms' : '');

      query[key] = [];
    });

    [...checked].map(item => {
      const slug = item.id.split('-')[0];
      const key = slug + (!['keywordInput', 'from_year', 'to_year'].includes(slug) ? '_terms' : '');

      newCheckedArray.push(item.id);
      query[key].push(item.id.split('-')[1] || item.value);
    });

    if (newCheckedArray.length > 0) {
      [...resets].map(reset => reset.removeAttribute('style'));
    }
    else {
      [...resets].map(reset => reset.style.display = 'none');
    }

    let params = '';
    let index = 0;

    for (let key in query) {
      params += index === 0 ? '?' : '&';
      params += `${key}=${query[key].join(',')}`;
      index++;
    }

    const filterData = new FormData(document.getElementById('filterForm'));
    filterData.lang = document.querySelector('main').getAttribute('lang');

    if (window.is_mobile) return;
    const resp = await fetch('/wp-json/publications/v1/get' + params, {
      'method': 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filterData),
    }).then(res => res.text());

    const articlesToDelete = document.querySelectorAll('.publications--listing > *');
    [...articlesToDelete].map(item => item.remove());

    window.history.pushState(resp, document.title, window.location.origin + window.location.pathname + params);

    listing.innerHTML += resp;
    displayPublicationListingFn();
  }, 200);
};

const resetFilter = () => {
  const button = document.getElementById('resetFilter');

  button?.addEventListener('click', () => {
    const checked = document.querySelectorAll('input:checked, input.pre-check, input.changed');

    [...checked].map(input => {
      input.checked = false;
      input.value = '';
      input.classList.remove('pre-check');
      input.dispatchEvent(new KeyboardEvent('keyup', {'key': 'Backspace'}));
    });

    detectChanges();
  });
};

/****
 *    Function : rangeHandle
 *    Usage : this functions aims to handle the filters of the publication archive page
 ****/
export function rangeHandle() {
  let sliderFrom = document.getElementById('from_year');
  let sliderTo = document.getElementById('to_year');
  let minGap = 0;
  let sliderTrack = document.querySelector('.slider-track');
  const rangeFrom = document.querySelector('.rangeFrom');
  const rangeTo = document.querySelector('.rangeTo');

  if (sliderFrom && sliderTo) {
    const min = parseFloat(sliderFrom.min);
    const max = parseFloat(sliderFrom.max);
    const offset = (max - min) + 1;
    const values = Array.from({length: offset}, (_, i) => min + i);

    setTimeout(() => fillColor(), 500)

    sliderFrom.addEventListener('input', e => {
      if (parseInt(sliderTo.value) - parseInt(sliderFrom.value) <= minGap) {
        sliderFrom.value = parseInt(sliderTo.value) - minGap;
      }
      if (rangeFrom) {
        rangeFrom.textContent = sliderFrom.value;
      }

      if (sliderFrom.value !== sliderFrom.dataset.value) {
        sliderFrom.classList.add('changed');
      }
      else {
        sliderFrom.classList.remove('changed');
      }

      detectChanges();

      fillColor();
    });

    sliderTo.addEventListener('input', e => {
      if (parseInt(sliderTo.value) - parseInt(sliderFrom.value) <= minGap) {
        sliderTo.value = parseInt(sliderFrom.value) + minGap;
      }
      if (rangeTo) {
        rangeTo.textContent = sliderTo.value;
      }

      if (sliderTo.value !== sliderTo.dataset.value) {
        sliderTo.classList.add('changed');
      }
      else {
        sliderTo.classList.remove('changed');
      }

      detectChanges();

      fillColor();
    });

    /*
    * Function : fillColor
    * Description : Updates the range line's size and color
    * */
    function fillColor() {
      const currentIndexFrom = values.findIndex(i => i === parseFloat(sliderFrom.value));
      const currentIndexTo = values.findIndex(i => i === parseFloat(sliderTo.value));

      const percentFrom = currentIndexFrom * 100 / (values.length - 1);
      const percentTo = currentIndexTo * 100 / (values.length - 1);

      gsap.set(rangeFrom, {
        x: (percentFrom * sliderFrom.getBoundingClientRect().width) / 100,
        marginLeft: -(rangeFrom.getBoundingClientRect().width / 2),
      });

      gsap.set(rangeTo, {
        x: (percentTo * sliderTo.getBoundingClientRect().width) / 100,
        marginLeft: -(rangeTo.getBoundingClientRect().width / 2),
      });

      sliderTrack.style.background = `linear-gradient(to right, var(--inputBG) ${percentFrom}% , var(--primary) ${percentFrom}% , var(--primary) ${percentTo}%, var(--inputBG) ${percentTo}%)`;
    }
  }
}

export default filterHandle;
